/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { localCompareTranslations } from "../../common/miscellaneous/localCompareTranslations";
import { Countries } from "./countriesAtom";

export function countriesWithTranslations(countries: Countries): Countries {
  return countries
    .map((country) => {
      return {
        ...country,
        translationKey: country.isoCode
          ? `mk-hc-country-${country.isoCode}`.toLocaleLowerCase()
          : undefined,
      };
    })
    .sort((countryA, countryB) => {
      return countryA.translationKey && countryB.translationKey
        ? localCompareTranslations(
            countryA.translationKey,
            countryB.translationKey
          )
        : 0;
    });
}
